/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/InvoicingDataLightReportPaginationSlice', 'model/CorporateStructureFilter'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/InvoicingDataLightReportPaginationSlice'), require('../model/CorporateStructureFilter'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.InvoicingDataApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.InvoicingDataLightReportPaginationSlice, root.ForStractionServiceApi.CorporateStructureFilter);
  }
}(this, function(ApiClient, InvoicingDataLightReportPaginationSlice, CorporateStructureFilter) {
  'use strict';

  /**
   * InvoicingData service.
   * @module api/InvoicingDataApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new InvoicingDataApi. 
   * @alias module:api/InvoicingDataApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the invoicingDataGetDimensionPreviewGet operation.
     * @callback module:api/InvoicingDataApi~invoicingDataGetDimensionPreviewGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'String'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * getDimensionPreview
     * @param {String} _4SAPIAppID 
     * @param {Integer} dimensionNumber 
     * @param {module:api/InvoicingDataApi~invoicingDataGetDimensionPreviewGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'String'>}
     */
    this.invoicingDataGetDimensionPreviewGet = function(_4SAPIAppID, dimensionNumber, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling invoicingDataGetDimensionPreviewGet";
      }

      // verify the required parameter 'dimensionNumber' is set
      if (dimensionNumber == undefined || dimensionNumber == null) {
        throw "Missing the required parameter 'dimensionNumber' when calling invoicingDataGetDimensionPreviewGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'dimensionNumber': dimensionNumber
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['String'];

      return this.apiClient.callApi(
        '/InvoicingData/getDimensionPreview', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the invoicingDataSearchLightReportSlicePut operation.
     * @callback module:api/InvoicingDataApi~invoicingDataSearchLightReportSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InvoicingDataLightReportPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchLightReportSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureFilter} body 
     * @param {Integer} regionID 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.order  (default to 0)
     * @param {module:api/InvoicingDataApi~invoicingDataSearchLightReportSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InvoicingDataLightReportPaginationSlice}
     */
    this.invoicingDataSearchLightReportSlicePut = function(_4SAPIAppID, body, regionID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling invoicingDataSearchLightReportSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling invoicingDataSearchLightReportSlicePut";
      }

      // verify the required parameter 'regionID' is set
      if (regionID == undefined || regionID == null) {
        throw "Missing the required parameter 'regionID' when calling invoicingDataSearchLightReportSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'regionID': regionID,
        'startDate': opts['startDate'],
        'endDate': opts['endDate'],
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'order': opts['order']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = InvoicingDataLightReportPaginationSlice;

      return this.apiClient.callApi(
        '/InvoicingData/searchLightReportSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
